import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-d8e05596"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dispose-drawer-body" }
const _hoisted_2 = { class: "dispose-top" }
const _hoisted_3 = { class: "dispose-card__actions" }
const _hoisted_4 = { class: "dispose-handle-card__scroll" }
const _hoisted_5 = { class: "dispose-option__head" }
const _hoisted_6 = { class: "dispose-option__desc" }
const _hoisted_7 = {
  key: 0,
  class: "dispose-option__form"
}

import { computed, reactive, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import Card from '@/views/dashboard/_components/card/card.vue'
import TerminalHead from '@/views/dashboard/group/client/terminal-info/terminal-head/terminal-head.vue'
import TerminalHeadRemoteActions from '@/views/dashboard/group/client/terminal-info/terminal-head/terminal-head-remote-actions.vue'
import { SelectTerminalDrawerService, Terminal } from '@/views/dashboard/_components/select-terminal-drawer/select-terminal-drawer.service'
import { ResponseHandlingService } from '@/views/dashboard/response-manage/response-handle/service'
import { isolation_status } from '@/views/dashboard/response-manage/response-handle/types'
import { resolveDisposeTitleType, trListEventLevel, trEventTypeDisplay, listLevelColor } from '../labels'
import {
  PermissionFe,
  ServicePermissionService,
} from '@/services/service-permission.service'
import { ApplyScope, DisposeActionType, ThreatEntityType } from '../constants/enums'
import {
  buildDefaultForm,
  buildDisposeActionOptions,
  extractDomainFromThreat,
  isStatusOnlyAction,
  isTrustAction,
} from '../dispose-strategy'
import { buildDisposePayload } from '../dispose-strategy-builder'
import { SecurityEventDisposeService } from '../security-event-dispose.service'
import { SecurityEventService } from '../security-event.service'
import type { SecurityEventDetail, SecurityEventListItem } from '../types'
import type { ClientItem } from '@/views/dashboard/_type/client-item'
import DisposeReadonlyValue from './dispose-readonly-value.vue'
import DisposeTimeline from './dispose-timeline.vue'
import DisposeFileContextForm from './dispose-file-context-form.vue'
import DisposeTrustContextForm from './dispose-trust-context-form.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'security-event-dispose',
  props: {
    modelValue: { type: Boolean },
    businessId: {},
    listRow: {}
  },
  emits: ["update:modelValue", "success", "view-detail"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const { t } = useI18n()
const injector = useReflectiveInjector([
  SecurityEventService,
  SecurityEventDisposeService,
  ResponseHandlingService,
  SelectTerminalDrawerService,
])
const securityEventService = injector.get(SecurityEventService)
const disposeService = injector.get(SecurityEventDisposeService)
const permService = injector.get(ServicePermissionService)
const responseHandleService = injector.get(ResponseHandlingService)
const selectTerminalDrawerService = injector.get(SelectTerminalDrawerService)

const detail = ref<SecurityEventDetail | null>(null)
const terminalInfo = ref<Terminal | null>(null)

const terminalDetailInfo = computed(() => {
  if (!detail.value && !terminalInfo.value) return null
  return {
    ...detail.value,
    ...terminalInfo.value,
  }
})
const selectedAction = ref<DisposeActionType>(DisposeActionType.MarkHandled)
const submitting = ref(false)
const loading = ref(false)
const form = reactive({
  protocol: '1',
  direction: '1',
  apply_scope: ApplyScope.Local as number,
})

const canBlockIp = permService.getHasPermission(PermissionFe.internet_ip_limit)
const canBlockUrl = permService.getHasPermission(PermissionFe.internet_url_limit)

const visible = computed({
  get: () => props.modelValue,
  set: (v) => emit('update:modelValue', v),
})

const drawerTitle = computed(() =>
  detail.value
    ? t('securityEvent.disposeTitle', { type: resolveDisposeTitleType(t, detail.value) })
    : '',
)

const blockDomainDisplay = computed(() =>
  detail.value ? extractDomainFromThreat(detail.value.threat_entity) : '',
)

const directionDisplay = computed(() => {
  if (!detail.value) return '--'
  const direction = detail.value.default_block_direction ?? 1
  const map: Record<number, string> = {
    1: t('ipAddressBlocking.directionBidirectionalLong'),
    2: t('ipAddressBlocking.directionInboundLong'),
    3: t('ipAddressBlocking.directionOutboundLong'),
  }
  return map[direction] ?? '--'
})

const processPidDisplay = computed(() => {
  const pid = detail.value?.process_pid
  return pid != null && pid !== '' ? String(pid) : '--'
})

const actionOptions = computed(() => {
  if (!detail.value) return []
  return buildDisposeActionOptions(detail.value, t, {
    canBlockIp,
    canBlockUrl,
  })
})

function isIsolationActive (status?: number) {
  return [isolation_status.separated, isolation_status.recovering, isolation_status.recoverFail].includes(
    status as isolation_status,
  )
}

function handleNet (row?: Partial<ClientItem> | null) {
  const item = row ?? detail.value
  if (!item?.device_id) return
  const isolated = isIsolationActive(detail.value?.isolation_status)
  const title = isolated ? t('responseHandle.confirmRestore') : t('responseHandle.confirmIsolate')
  const subtitle = isolated ? t('responseHandle.confirmRestoreDesc') : t('responseHandle.confirmIsolateDesc')
  ElMessageBox.confirm(
    `<div>
  <strong style='color: var(--cm-color-text-primary);font-size: 16px;font-weight: 700;'>${title}</strong>
  <div style='color: var(--cm-color-text-secondary);margin-top:10px'>${subtitle}</div>
  </div>`,
    t('responseHandle.tip'),
    { dangerouslyUseHTMLString: true },
  ).then(async () => {
    await responseHandleService.getTerminalOrderIsolation({
      execute_type: 0,
      device_list: [item.device_id],
      isolation_enabled: isolated ? isolation_status.disSeparated : isolation_status.separated,
    })
    ElMessage.success(t('responseHandle.opSuccess'))
    if (detail.value?.device_id === item.device_id) {
      detail.value.isolation_status = isolated
        ? isolation_status.disSeparated
        : isolation_status.separated
    }
  })
}

function applyDefaultForm () {
  if (!detail.value) return
  const defaults = buildDefaultForm(detail.value)
  form.protocol = defaults.protocol
  form.direction = defaults.direction
  form.apply_scope = defaults.apply_scope
}

async function loadDetail () {
  if (!props.businessId) return
  loading.value = true
  try {
    detail.value = null
    terminalInfo.value = null
    detail.value =
      (await securityEventService.getDetail(
        props.businessId,
        props.listRow ?? undefined,
      )) ?? null
    if (detail.value?.device_id) {
      const res = await selectTerminalDrawerService.getTerminalInfo({ device_id: detail.value.device_id })
      if (res?.terminal) {
        terminalInfo.value = res.terminal
      }
    }
    applyDefaultForm()
    selectedAction.value =
      actionOptions.value.find((o) => !o.disabled)?.value ?? DisposeActionType.MarkHandled
  } finally {
    loading.value = false
  }
}

async function onSubmit () {
  if (!detail.value) return
  submitting.value = true
  const payload = buildDisposePayload(detail.value, selectedAction.value, form)
  const ok = await disposeService.execute(detail.value, payload, t)
  submitting.value = false
  if (ok) {
    visible.value = false
    emit('success')
  }
}

watch(
  () => [props.modelValue, props.businessId] as const,
  ([open, id]) => {
    if (open && id) void loadDetail()
  },
)

return (_ctx: any,_cache: any) => {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((visible).value = $event)),
    class: "security-event-dispose-drawer",
    title: drawerTitle.value,
    size: "70%",
    "destroy-on-close": ""
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        (detail.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_2, [
                (terminalDetailInfo.value?.device_id)
                  ? (_openBlock(), _createBlock(TerminalHead, {
                      key: 0,
                      "system-type": (terminalDetailInfo.value.system_type as number) ?? 1,
                      "login-status": (terminalDetailInfo.value.login_status as number) ?? 2,
                      "detail-info": terminalDetailInfo.value
                    }, {
                      "right-action": _withCtx(() => [
                        _createVNode(TerminalHeadRemoteActions, {
                          "detail-info": terminalDetailInfo.value,
                          onHandleNet: handleNet
                        }, null, 8, ["detail-info"])
                      ]),
                      _: 1
                    }, 8, ["system-type", "login-status", "detail-info"]))
                  : _createCommentVNode("", true),
                (detail.value.threat_entity_type == null)
                  ? (_openBlock(), _createBlock(_component_el_alert, {
                      key: 1,
                      class: "cm-ui-mt16",
                      type: "warning",
                      closable: false,
                      "show-icon": "",
                      title: _ctx.$t('securityEvent.threatTypeUnknown')
                    }, null, 8, ["title"]))
                  : _createCommentVNode("", true),
                _createVNode(Card, {
                  size: "third",
                  class: "cm-ui-mt16 cm-ui-mb16 dispose-handle-card",
                  title: _ctx.$t('securityEvent.disposeSectionHandle')
                }, {
                  headerRight: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_el_button, {
                        size: "small",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        type: "primary",
                        size: "small",
                        loading: submitting.value,
                        onClick: onSubmit
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('common.confirm')), 1)
                        ]),
                        _: 1
                      }, 8, ["loading"])
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_el_radio_group, {
                        modelValue: selectedAction.value,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((selectedAction).value = $event)),
                        class: "dispose-options"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actionOptions.value, (opt) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: opt.value,
                              class: _normalizeClass(["dispose-option", { 'is-disabled': opt.disabled }])
                            }, [
                              _createVNode(_component_el_tooltip, {
                                disabled: !opt.disabled || !opt.tip,
                                content: opt.tip || '',
                                placement: "top"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_5, [
                                    _createVNode(_component_el_radio, {
                                      label: opt.value,
                                      disabled: opt.disabled
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(opt.label), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "disabled"])
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["disabled", "content"]),
                              _createElementVNode("p", _hoisted_6, [
                                _createTextVNode(_toDisplayString(opt.desc) + " ", 1),
                                (opt.value === _unref(DisposeActionType).TrustUrl)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      class: "dispose-option__detail-link",
                                      href: "javascript:;",
                                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (emit('view-detail')), ["prevent"]))
                                    }, _toDisplayString(_ctx.$t('securityEvent.viewEventDetail')), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              (selectedAction.value === opt.value && !opt.disabled && !_unref(isStatusOnlyAction)(opt.value))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    (opt.value === _unref(DisposeActionType).BlockIp)
                                      ? (_openBlock(), _createBlock(_component_el_form, {
                                          key: 0,
                                          "label-position": "left",
                                          "label-width": "auto",
                                          size: "small",
                                          class: "dispose-form"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_form_item, {
                                              label: _ctx.$t('securityEvent.labelIp')
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(DisposeReadonlyValue, {
                                                  value: detail.value.threat_entity
                                                }, null, 8, ["value"])
                                              ]),
                                              _: 1
                                            }, 8, ["label"]),
                                            _createVNode(_component_el_form_item, {
                                              label: _ctx.$t('ipAddressBlocking.protocol')
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_el_radio_group, {
                                                  modelValue: form.protocol,
                                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.protocol) = $event)),
                                                  size: "small"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_el_radio, { label: "1" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t('ipAddressBlocking.protocolAny')), 1)
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_el_radio, { label: "2" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode("TCP")
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_el_radio, { label: "3" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode("UDP")
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }, 8, ["modelValue"])
                                              ]),
                                              _: 1
                                            }, 8, ["label"]),
                                            _createVNode(_component_el_form_item, {
                                              label: _ctx.$t('ipAddressBlocking.interceptDirection')
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(DisposeReadonlyValue, { value: directionDisplay.value }, null, 8, ["value"])
                                              ]),
                                              _: 1
                                            }, 8, ["label"]),
                                            (opt.showApplyScope)
                                              ? (_openBlock(), _createBlock(_component_el_form_item, {
                                                  key: 0,
                                                  label: _ctx.$t('securityEvent.applyScope')
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_el_select, {
                                                      modelValue: form.apply_scope,
                                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.apply_scope) = $event)),
                                                      size: "small",
                                                      style: {"width":"240px"}
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_el_option, {
                                                          label: _ctx.$t('securityEvent.scopeLocal'),
                                                          value: _unref(ApplyScope).Local
                                                        }, null, 8, ["label", "value"]),
                                                        _createVNode(_component_el_option, {
                                                          label: _ctx.$t('securityEvent.scopeAll'),
                                                          value: _unref(ApplyScope).AllEndpoints
                                                        }, null, 8, ["label", "value"])
                                                      ]),
                                                      _: 1
                                                    }, 8, ["modelValue"])
                                                  ]),
                                                  _: 1
                                                }, 8, ["label"]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : (opt.value === _unref(DisposeActionType).BlockUrl)
                                        ? (_openBlock(), _createBlock(_component_el_form, {
                                            key: 1,
                                            "label-position": "left",
                                            "label-width": "auto",
                                            size: "small",
                                            class: "dispose-form"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_form_item, {
                                                label: _ctx.$t('securityEvent.labelDomain')
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(DisposeReadonlyValue, { value: blockDomainDisplay.value }, null, 8, ["value"])
                                                ]),
                                                _: 1
                                              }, 8, ["label"]),
                                              (opt.showApplyScope)
                                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                                    key: 0,
                                                    label: _ctx.$t('securityEvent.applyScope')
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_el_select, {
                                                        modelValue: form.apply_scope,
                                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.apply_scope) = $event)),
                                                        size: "small",
                                                        style: {"width":"240px"}
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_el_option, {
                                                            label: _ctx.$t('securityEvent.scopeLocal'),
                                                            value: _unref(ApplyScope).Local
                                                          }, null, 8, ["label", "value"]),
                                                          _createVNode(_component_el_option, {
                                                            label: _ctx.$t('securityEvent.scopeAll'),
                                                            value: _unref(ApplyScope).AllEndpoints
                                                          }, null, 8, ["label", "value"])
                                                        ]),
                                                        _: 1
                                                      }, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  }, 8, ["label"]))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : (opt.value === _unref(DisposeActionType).KillProcess)
                                          ? (_openBlock(), _createBlock(_component_el_form, {
                                              key: 2,
                                              "label-position": "left",
                                              "label-width": "auto",
                                              size: "small",
                                              class: "dispose-form"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_el_form_item, {
                                                  label: _ctx.$t('securityEvent.labelProcessPid')
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(DisposeReadonlyValue, { value: processPidDisplay.value }, null, 8, ["value"])
                                                  ]),
                                                  _: 1
                                                }, 8, ["label"]),
                                                _createVNode(_component_el_form_item, {
                                                  label: _ctx.$t('securityEvent.labelProcessPath')
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(DisposeReadonlyValue, {
                                                      value: detail.value.process_path,
                                                      multiline: ""
                                                    }, null, 8, ["value"])
                                                  ]),
                                                  _: 1
                                                }, 8, ["label"])
                                              ]),
                                              _: 1
                                            }))
                                          : (opt.value === _unref(DisposeActionType).IsolateFile)
                                            ? (_openBlock(), _createBlock(DisposeFileContextForm, {
                                                key: 3,
                                                detail: detail.value
                                              }, null, 8, ["detail"]))
                                            : (_unref(isTrustAction)(opt.value))
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                                  (detail.value.threat_entity_type === _unref(ThreatEntityType).BehaviorHash)
                                                    ? (_openBlock(), _createBlock(DisposeTrustContextForm, {
                                                        key: 0,
                                                        detail: detail.value,
                                                        "show-apply-scope": opt.showApplyScope,
                                                        "apply-scope": form.apply_scope,
                                                        "onUpdate:applyScope": _cache[5] || (_cache[5] = ($event: any) => ((form.apply_scope) = $event))
                                                      }, null, 8, ["detail", "show-apply-scope", "apply-scope"]))
                                                    : (detail.value.threat_entity_type === _unref(ThreatEntityType).File)
                                                      ? (_openBlock(), _createBlock(DisposeFileContextForm, {
                                                          key: 1,
                                                          detail: detail.value,
                                                          "show-apply-scope": opt.showApplyScope,
                                                          "apply-scope": form.apply_scope,
                                                          "onUpdate:applyScope": _cache[6] || (_cache[6] = ($event: any) => ((form.apply_scope) = $event))
                                                        }, null, 8, ["detail", "show-apply-scope", "apply-scope"]))
                                                      : (_openBlock(), _createBlock(_component_el_form, {
                                                          key: 2,
                                                          "label-position": "left",
                                                          "label-width": "auto",
                                                          size: "small",
                                                          class: "dispose-form"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            (detail.value.threat_entity_type === _unref(ThreatEntityType).Ip)
                                                              ? (_openBlock(), _createBlock(_component_el_form_item, {
                                                                  key: 0,
                                                                  label: _ctx.$t('securityEvent.labelIp')
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(DisposeReadonlyValue, {
                                                                      value: detail.value.threat_entity
                                                                    }, null, 8, ["value"])
                                                                  ]),
                                                                  _: 1
                                                                }, 8, ["label"]))
                                                              : (detail.value.threat_entity_type === _unref(ThreatEntityType).Url)
                                                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                                                    key: 1,
                                                                    label: _ctx.$t('securityEvent.labelUrl')
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      _createVNode(DisposeReadonlyValue, {
                                                                        value: detail.value.threat_entity,
                                                                        multiline: ""
                                                                      }, null, 8, ["value"])
                                                                    ]),
                                                                    _: 1
                                                                  }, 8, ["label"]))
                                                                : (detail.value.threat_entity_type === _unref(ThreatEntityType).Process)
                                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                                      _createVNode(_component_el_form_item, {
                                                                        label: _ctx.$t('securityEvent.labelProcessPid')
                                                                      }, {
                                                                        default: _withCtx(() => [
                                                                          _createVNode(DisposeReadonlyValue, { value: processPidDisplay.value }, null, 8, ["value"])
                                                                        ]),
                                                                        _: 1
                                                                      }, 8, ["label"]),
                                                                      _createVNode(_component_el_form_item, {
                                                                        label: _ctx.$t('securityEvent.labelProcessPath')
                                                                      }, {
                                                                        default: _withCtx(() => [
                                                                          _createVNode(DisposeReadonlyValue, {
                                                                            value: detail.value.process_path,
                                                                            multiline: ""
                                                                          }, null, 8, ["value"])
                                                                        ]),
                                                                        _: 1
                                                                      }, 8, ["label"])
                                                                    ], 64))
                                                                  : _createCommentVNode("", true),
                                                            (opt.showApplyScope)
                                                              ? (_openBlock(), _createBlock(_component_el_form_item, {
                                                                  key: 3,
                                                                  label: _ctx.$t('securityEvent.applyScope')
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_el_select, {
                                                                      modelValue: form.apply_scope,
                                                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.apply_scope) = $event)),
                                                                      size: "small",
                                                                      style: {"width":"240px"}
                                                                    }, {
                                                                      default: _withCtx(() => [
                                                                        _createVNode(_component_el_option, {
                                                                          label: _ctx.$t('securityEvent.scopeLocal'),
                                                                          value: _unref(ApplyScope).Local
                                                                        }, null, 8, ["label", "value"]),
                                                                        _createVNode(_component_el_option, {
                                                                          label: _ctx.$t('securityEvent.scopeAll'),
                                                                          value: _unref(ApplyScope).AllEndpoints
                                                                        }, null, 8, ["label", "value"])
                                                                      ]),
                                                                      _: 1
                                                                    }, 8, ["modelValue"])
                                                                  ]),
                                                                  _: 1
                                                                }, 8, ["label"]))
                                                              : _createCommentVNode("", true)
                                                          ]),
                                                          _: 2
                                                        }, 1024))
                                                ], 64))
                                              : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _: 1
                }, 8, ["title"])
              ]),
              (detail.value.log.length)
                ? (_openBlock(), _createBlock(Card, {
                    key: 0,
                    size: "second",
                    class: "dispose-timeline-card",
                    title: _ctx.$t('securityEvent.disposeSectionTimeline')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(DisposeTimeline, {
                        items: detail.value.log || []
                      }, null, 8, ["items"])
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ])), [
        [_directive_loading, loading.value]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})